import { render, staticRenderFns } from "./segment-value-input.vue?vue&type=template&id=0154f1b2"
import script from "./segment-value-input.vue?vue&type=script&lang=js"
export * from "./segment-value-input.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports